;(function (Wishlist, $) {
  'use strict';

  var ITEMS_KEY = 'wishtems';
  var COUNT_KEY = 'wishtemscount';
  var BUTTON_SELECTOR = '.wishremove, .fps-wishlist-inline, .cps-wishlist-inline, .product-card-wishlist';
  var feedbackTimer;
  var wishlist = readWishlist();

  function uniqueHandles(value) {
    var result = [];
    if (!Array.isArray(value)) return result;

    value.forEach(function (handle) {
      if (typeof handle === 'string' && handle && result.indexOf(handle) === -1) {
        result.push(handle);
      }
    });
    return result;
  }

  function readWishlist() {
    try {
      return uniqueHandles(JSON.parse(localStorage.getItem(ITEMS_KEY) || '[]'));
    } catch (error) {
      return [];
    }
  }

  function persistWishlist(nextWishlist) {
    var previousItems;
    var previousCount;

    try {
      previousItems = localStorage.getItem(ITEMS_KEY);
      previousCount = localStorage.getItem(COUNT_KEY);
      localStorage.setItem(ITEMS_KEY, JSON.stringify(nextWishlist));
      localStorage.setItem(COUNT_KEY, String(nextWishlist.length));
      return true;
    } catch (error) {
      try {
        if (previousItems === null) localStorage.removeItem(ITEMS_KEY);
        else localStorage.setItem(ITEMS_KEY, previousItems);
        if (previousCount === null) localStorage.removeItem(COUNT_KEY);
        else localStorage.setItem(COUNT_KEY, previousCount);
      } catch (rollbackError) {
        // The UI remains on the last confirmed in-memory state.
      }
      return false;
    }
  }

  function escapeSelector(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return value.replace(/([ #;&,.+*~':"!^$[\]()=>|/@])/g, '\\$1');
  }

  function setButtonState($button, isActive) {
    var label = isActive ? 'お気に入りから削除' : 'お気に入りに追加';
    $button.toggleClass('wishactive', isActive);
    $button.attr('aria-pressed', isActive ? 'true' : 'false');
    $button.attr('aria-label', label);
    $button.attr('title', label);
    $button.find('[data-wishlist-label]').text(label);
  }

  function syncHandle(productHandle, isActive) {
    $('[data-product-handle="' + escapeSelector(productHandle) + '"]').filter(BUTTON_SELECTOR).each(function () {
      setButtonState($(this), isActive);
    });
  }

  function syncCount() {
    $('.wishcount').text(wishlist.length);
    $('.header-wishlist-count').prop('hidden', wishlist.length === 0);
    $('[data-wishlist-count]').attr('aria-label', 'お気に入り ' + wishlist.length + '件');
  }

  function syncAllButtons() {
    $(BUTTON_SELECTOR).each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (productHandle) setButtonState($(this), wishlist.indexOf(productHandle) !== -1);
    });
    syncCount();
  }

  function feedbackElement() {
    var $status = $('[data-wishlist-status]').first();
    if ($status.length) return $status;

    $status = $('<div class="wishlist-feedback" data-wishlist-status role="status" aria-live="polite" aria-atomic="true"></div>');
    $('body').append($status);
    return $status;
  }

  function announce(message, isError) {
    var $status = feedbackElement();
    window.clearTimeout(feedbackTimer);
    $status.removeClass('is-visible is-error');
    $status[0].offsetWidth;
    $status.text(message).toggleClass('is-error', Boolean(isError)).addClass('is-visible');
    feedbackTimer = window.setTimeout(function () {
      $status.removeClass('is-visible');
    }, 2600);
  }

  function toggleWishlist(button) {
    var $button = $(button);
    var productHandle = $button.attr('data-product-handle');
    if (!productHandle || $button.attr('aria-busy') === 'true') return;

    var isActive = wishlist.indexOf(productHandle) !== -1;
    var nextWishlist = wishlist.slice();
    var $matchingButtons = $('[data-product-handle="' + escapeSelector(productHandle) + '"]').filter(BUTTON_SELECTOR);
    $matchingButtons.attr('aria-busy', 'true').addClass('wishadding');

    if (isActive) {
      nextWishlist = nextWishlist.filter(function (handle) { return handle !== productHandle; });
    } else {
      nextWishlist.push(productHandle);
      nextWishlist = uniqueHandles(nextWishlist);
    }

    if (!persistWishlist(nextWishlist)) {
      syncHandle(productHandle, isActive);
      announce('お気に入りを更新できませんでした', true);
    } else {
      wishlist = nextWishlist;
      syncHandle(productHandle, !isActive);
      syncCount();
      displayWishItems();
      announce(isActive ? 'お気に入りから削除しました' : 'お気に入りに追加しました', false);
      $(document).trigger('wishlist:changed', [wishlist.slice()]);
    }

    window.setTimeout(function () {
      $matchingButtons.removeClass('wishadding').removeAttr('aria-busy');
    }, 350);
  }

  function displayWishItems() {
    if (window.location.pathname.indexOf('/pages/wishlist') === -1) return;

    var visibleCount = 0;
    $('.cart[data-product-handle]').each(function () {
      var isVisible = wishlist.indexOf($(this).attr('data-product-handle')) !== -1;
      $(this).toggle(isVisible);
      if (isVisible) visibleCount += 1;
    });

    $('.main-wishlist').addClass('wl-filtered');
    $('.wishloader').hide();
    $('.mainwish .wishlist-hero').addClass('wishvisible');
    $('.wishempty').toggleClass('wishvisible', visibleCount === 0).toggle(visibleCount === 0);
    $('.mainwish').toggle(visibleCount !== 0);
  }

  function bindUIActions() {
    $(document).off('click.cieloWishlist', BUTTON_SELECTOR).on('click.cieloWishlist', BUTTON_SELECTOR, function (event) {
      event.preventDefault();
      toggleWishlist(this);
    });

    $(document).off('click.cieloWishlistClear', '#wishcall, #wishcall2').on('click.cieloWishlistClear', '#wishcall, #wishcall2', function (event) {
      event.preventDefault();
      if (!persistWishlist([])) {
        announce('お気に入りを更新できませんでした', true);
        return;
      }
      wishlist = [];
      syncAllButtons();
      displayWishItems();
      announce('お気に入りをすべて削除しました', false);
    });

    $(window).off('storage.cieloWishlist').on('storage.cieloWishlist', function (event) {
      if (event.originalEvent.key === ITEMS_KEY || event.originalEvent.key === COUNT_KEY) {
        wishlist = readWishlist();
        syncAllButtons();
        displayWishItems();
      }
    });

    $(window).off('pageshow.cieloWishlist').on('pageshow.cieloWishlist', function () {
      wishlist = readWishlist();
      syncAllButtons();
      displayWishItems();
    });

    $(document).off('wishlist:refresh.cieloWishlist').on('wishlist:refresh.cieloWishlist', syncAllButtons);
  }

  Wishlist.init = function () {
    wishlist = readWishlist();
    persistWishlist(wishlist);
    bindUIActions();
    syncAllButtons();
    displayWishItems();
    window.setTimeout(syncAllButtons, 500);
  };

  Wishlist.refresh = syncAllButtons;
  Wishlist.getItems = function () { return wishlist.slice(); };
}(window.Wishlist = window.Wishlist || {}, jQuery));
